'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _keys = require('babel-runtime/core-js/object/keys');

var _keys2 = _interopRequireDefault(_keys);

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _dec2, _class, _class2, _temp2;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require('react-redux');

var _reduxAsyncConnect = require('redux-async-connect');

var _schoollevels = require('redux/modules/schoollevels');

var _strings = require('utils/strings');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var NewSchoolLevel = (_dec = (0, _reduxAsyncConnect.asyncConnect)([{
  deferred: false,
  promise: function promise(_ref) {
    var _ref$store = _ref.store,
        dispatch = _ref$store.dispatch,
        getState = _ref$store.getState;

    if (!(0, _schoollevels.isLoaded)(getState())) {
      return dispatch((0, _schoollevels.load)());
    }
  }
}]), _dec2 = (0, _reactRedux.connect)(function (state) {
  return {
    schoolLevels: state.schoolLevels.data,
    loading: state.schoolLevels.loading,
    error: state.schoolLevels.error
  };
}), _dec(_class = _dec2(_class = (_temp2 = _class2 = function (_Component) {
  (0, _inherits3.default)(NewSchoolLevel, _Component);

  function NewSchoolLevel() {
    var _ref2;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, NewSchoolLevel);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref2 = NewSchoolLevel.__proto__ || (0, _getPrototypeOf2.default)(NewSchoolLevel)).call.apply(_ref2, [this].concat(args))), _this), _this.state = {
      name: undefined,
      shortName: undefined,
      slug: undefined,
      fieldErrors: [],
      error: undefined
    }, _this.handleFieldChange = function (param, event) {
      var _this$setState;

      var fieldErrors = _this.state.fieldErrors;
      fieldErrors[param] = null;

      if (param === 'name') {
        _this.setState({
          slug: (0, _strings.slugify)(event.target.value)
        });
      }

      _this.setState((_this$setState = {}, (0, _defineProperty3.default)(_this$setState, param, event.target.value), (0, _defineProperty3.default)(_this$setState, 'fieldErrors', fieldErrors), _this$setState));
    }, _this.handleCreateNewSchoolLevel = function (event) {
      event.preventDefault();

      _this.setState({
        fieldErrors: {},
        error: undefined
      });

      var fieldErrors = {};
      if (!_this.state.name) {
        fieldErrors.name = 'Champs requis';
      }
      if (!_this.state.shortName) {
        fieldErrors.shortName = 'Champs requis';
      }
      if (!_this.state.slug) {
        fieldErrors.slug = 'Champs requis';
      }

      _this.setState({ fieldErrors: fieldErrors });

      if ((0, _keys2.default)(fieldErrors).length === 0) {
        _this.props.dispatch((0, _schoollevels.create)({
          name: _this.state.name,
          shortName: _this.state.shortName,
          slug: _this.state.slug
        }));
      }
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(NewSchoolLevel, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      this.setState({
        loading: nextProps.loading,
        error: nextProps.error
      });
      var _props = this.props,
          loading = _props.loading,
          history = _props.history;

      if (loading === true && loading !== nextProps.loading) {
        if (!nextProps.error) {
          history.push('/schoollevels');
        }
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var styles = require('./NewSchoolLevel.scss');
      var _state = this.state,
          fieldErrors = _state.fieldErrors,
          loading = _state.loading,
          error = _state.error,
          name = _state.name,
          slug = _state.slug,
          shortName = _state.shortName;
      // require the logo image both from client and server

      return _react2.default.createElement(
        'div',
        { className: styles.schoolLevels },
        _react2.default.createElement(
          'section',
          { className: styles.box },
          _react2.default.createElement(
            'h1',
            { className: styles.boxTitle },
            'Cr\xE9er un niveau'
          ),
          _react2.default.createElement('div', { className: styles.boxBar })
        ),
        _react2.default.createElement(
          'div',
          { className: styles.content },
          _react2.default.createElement(
            'section',
            { className: styles.box },
            _react2.default.createElement(
              'div',
              null,
              _react2.default.createElement(
                'form',
                { className: styles.form },
                _react2.default.createElement(
                  'div',
                  { className: styles.line },
                  _react2.default.createElement(
                    'label',
                    { className: styles.inputFieldLabel,
                      htmlFor: 'name' },
                    'Nom'
                  ),
                  _react2.default.createElement('input', { className: styles.inputFieldInput,
                    type: 'text',
                    name: 'name',
                    value: name,
                    onChange: this.handleFieldChange.bind(null, 'name'),
                    onEnterPress: this.handleCreateNewSchoolLevel }),
                  _react2.default.createElement(
                    'div',
                    { className: styles.inputFieldError },
                    fieldErrors.name
                  )
                ),
                _react2.default.createElement(
                  'div',
                  { className: styles.line },
                  _react2.default.createElement(
                    'label',
                    { className: styles.inputFieldLabel,
                      htmlFor: 'name' },
                    'Abbr\xE9viation'
                  ),
                  _react2.default.createElement('input', { className: styles.inputFieldInput,
                    type: 'text',
                    name: 'shortName',
                    value: shortName,
                    onChange: this.handleFieldChange.bind(null, 'shortName'),
                    onEnterPress: this.handleCreateNewSchoolLevel }),
                  _react2.default.createElement(
                    'span',
                    { className: styles.inputFieldError },
                    fieldErrors.shortName
                  )
                ),
                _react2.default.createElement(
                  'div',
                  { className: styles.line },
                  _react2.default.createElement(
                    'label',
                    { className: styles.inputFieldLabel,
                      htmlFor: 'name' },
                    'URL'
                  ),
                  _react2.default.createElement('input', { className: styles.inputFieldInput,
                    type: 'text',
                    name: 'slug',
                    value: slug,
                    disabled: 'disabled',
                    onEnterPress: this.handleCreateNewSchoolLevel }),
                  _react2.default.createElement(
                    'div',
                    { className: styles.inputFieldError },
                    fieldErrors.slug
                  )
                ),
                error ? _react2.default.createElement(
                  'div',
                  { className: styles.inputFieldError },
                  'Erreur lors de l\'enregistrement (',
                  error.statusCode,
                  ': ',
                  error.message,
                  ')'
                ) : null,
                !loading ? _react2.default.createElement(
                  'div',
                  { className: styles.line },
                  _react2.default.createElement('input', { type: 'submit',
                    value: 'Cr\xE9er',
                    onClick: this.handleCreateNewSchoolLevel })
                ) : _react2.default.createElement(
                  'span',
                  null,
                  'Enregistrement en cours'
                )
              )
            )
          )
        )
      );
    }
  }]);
  return NewSchoolLevel;
}(_react.Component), _class2.propTypes = {
  schoolLevels: _react.PropTypes.array,
  dispatch: _react.PropTypes.func.required,
  history: _react.PropTypes.func.required,
  loading: _react.PropTypes.bool.required,
  error: _react.PropTypes.object.required
}, _temp2)) || _class) || _class);
exports.default = NewSchoolLevel;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/containers/NewSchoolLevel/NewSchoolLevel.js
// module id = 1192
// module chunks = 0